var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('input',{class:{ active: _vm.value },attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event.target.value)}}}),_c('label',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }